'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var containerStyle = {
    overflow: 'hidden',
    position: 'relative'
},
    zoomStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    opacity: 0,
    border: 'none',
    maxWidth: 'none',
    maxHeight: 'none'
};

var ImageZoomer = function (_Component) {
    (0, _inherits3.default)(ImageZoomer, _Component);

    function ImageZoomer(props) {
        (0, _classCallCheck3.default)(this, ImageZoomer);

        var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ImageZoomer).call(this, props));

        _this.containerOffset = {};
        _this.ratio = {};
        _this.state = {
            zoomStyle: zoomStyle,
            hasLoaded: false
        };
        return _this;
    }

    (0, _createClass3.default)(ImageZoomer, [{
        key: 'onMouseEnter',
        value: function onMouseEnter(event) {
            event.preventDefault();

            function offset(elt) {
                var rect = elt.getBoundingClientRect(),
                    bodyElt = document.body;
                return {
                    top: rect.top + bodyElt.scrollTop,
                    left: rect.left + bodyElt.scrollLeft
                };
            }

            var container = this.refs.container;

            this.containerOffset = (0, _assign2.default)({}, offset(container), { width: container.clientWidth, height: container.clientHeight });

            var width = this.refs.zoomImage.width,
                height = this.refs.zoomImage.height;

            if (width == 0) width = this.props.zoomSize;
            if (height == 0) height = this.props.zoomSize;

            zoomStyle = (0, _assign2.default)({}, zoomStyle, { width: width, height: height });

            this.ratio = {
                xRatio: (width - this.containerOffset.width) / this.containerOffset.width,
                yRatio: (height - this.containerOffset.height) / this.containerOffset.height
            };

            this.props.onZoomIn();
        }
    }, {
        key: 'onMouseMove',
        value: function onMouseMove(event) {
            event.preventDefault();

            var offset = this.containerOffset,
                top = event.pageY - offset.top,
                left = event.pageX - offset.left;

            top = Math.max(Math.min(top, offset.height), 0) * -this.ratio.yRatio;
            left = Math.max(Math.min(left, offset.width), 0) * -this.ratio.xRatio;

            this.setState({
                zoomStyle: (0, _assign2.default)({}, zoomStyle, { opacity: 1, left: left, top: top })
            });
        }
    }, {
        key: 'onMouseLeave',
        value: function onMouseLeave(event) {
            event.preventDefault();

            this.setState({
                zoomStyle: (0, _assign2.default)({}, this.state.zoomStyle, { opacity: 0 })
            });

            this.props.onZoomOut();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var hasLoaded = this.state.hasLoaded;


            if (hasLoaded) {
                return _react2.default.createElement(
                    'div',
                    { onMouseEnter: this.onMouseEnter.bind(this),
                        onMouseMove: this.onMouseMove.bind(this),
                        onMouseLeave: this.onMouseLeave.bind(this),
                        onTouchStart: this.onMouseEnter.bind(this),
                        onTouchMove: this.onMouseMove.bind(this),
                        onTouchEnd: this.onMouseLeave.bind(this),
                        style: containerStyle,
                        className: this.props.className,
                        ref: 'container' },
                    _react2.default.createElement('img', { src: this.props.zoomSrc, alt: this.props.alt }),
                    _react2.default.createElement('img', { src: this.props.zoomSrc, style: this.state.zoomStyle, ref: 'zoomImage', alt: this.props.alt })
                );
            } else {
                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('img', { src: this.props.src, style: { height: '80vh' }, alt: this.props.alt }),
                    _react2.default.createElement('img', { src: this.props.zoomSrc, onLoad: function onLoad() {
                            return _this2.setState({ hasLoaded: true });
                        }, style: { display: 'none' }, alt: this.props.alt })
                );
            }
        }
    }]);
    return ImageZoomer;
}(_react.Component);

ImageZoomer.displayName = 'ImageZoomer';

ImageZoomer.propTypes = {
    src: _react.PropTypes.string.isRequired,
    zoomSrc: _react.PropTypes.string.isRequired,
    className: _react.PropTypes.string,
    alt: _react.PropTypes.string,
    onZoomIn: _react.PropTypes.func,
    onZoomOut: _react.PropTypes.func,
    zoomSize: _react.PropTypes.number
};

ImageZoomer.defaultProps = {
    onZoomIn: function onZoomIn() {},
    onZoomOut: function onZoomOut() {},
    zoomSize: 1000
};

exports.default = ImageZoomer;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ImageZoomer/ImageZoomer.js
 ** module id = 1093
 ** module chunks = 0
 **/